<template src="./AppFooter.html"></template>

<script>
import { mapState } from "vuex";

export default {
  name: "app-footer",

  computed: {
    ...mapState({
      weather: (state) => state.weatherData.weather,
    }),
  },
};
</script>
